/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useRef, useState, useEffect } from "react";
import axios from "axios";
import { OnmaxContext } from "../OnmaxContext";
import { useNavigate } from "react-router-dom";
import Header from "./Comman/Header";
import Sidebar from "./Comman/Sidebar";

export default function OTPVerify2() {
  const { toastSuccess, toastError } = useContext(OnmaxContext);
  const [timer, setTimer] = useState(180);
  const [canResend, setCanResend] = useState(false);
  const email = localStorage.getItem("email");
  const navigate = useNavigate();
  const inputsRef = useRef([]);
  const [isVerifying, setIsVerifying] = useState(false);

  // 🔥 TIMER LOGIC
  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((sec) => {
        if (sec <= 1) {
          setCanResend(true);
          clearInterval(interval);
          return 0;
        }
        return sec - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = () => {
    const minutes = Math.floor(timer / 60);
    const seconds = timer % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  const resendOTP = async () => {
    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "rsend",
        key: process.env.REACT_APP_KEY,
        email: email
      });

      if (res.data.resCode === 200) {
        toastSuccess("OTP Resent Successfully!");
        setTimer(180);
        setCanResend(false);
        inputsRef.current.forEach((i) => { if (i) i.value = ""; });
        inputsRef.current[0].focus();
      } else {
        toastError(res.data.error || "Failed to resend OTP");
      }
    } catch (error) {
      toastError("Failed to resend OTP");
    }
  };

  const verifyOTP = async (e) => {
    if (e) e.preventDefault();
    if (isVerifying) return;

    const otp = inputsRef.current.map((i) => i.value).join("");
    if (otp.length !== 6) {
      toastError("Please enter the 6-digit code");
      return;
    }

    try {
      setIsVerifying(true);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "verifyemail",
        key: process.env.REACT_APP_KEY,
        email: email,
        otp: otp,
      });

      if (res.data?.resCode === 200) {
        toastSuccess(res.data.message || "Email Verified Successfully!");
        setTimeout(() => navigate("/dashboard"), 1500);
      } else {
        toastError(res.data.message || "Invalid security code");
      }
    } catch (error) {
      toastError("Verification failed. Please try again.");
    } finally {
      setIsVerifying(false);
    }
  };

  const handleInput = (e, index) => {
    const value = e.target.value;
    if (!/^[0-9]?$/.test(value)) {
      e.target.value = "";
      return;
    }
    if (value && index < 5) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").trim();
    if (!/^\d{6}$/.test(pasteData)) return;

    const digits = pasteData.split("");
    digits.forEach((digit, i) => {
      if (inputsRef.current[i]) {
        inputsRef.current[i].value = digit;
      }
    });

    inputsRef.current[5].focus();
    setTimeout(() => verifyOTP(), 100);
  };

  const customStyles = `
    .ai-auth-container {
        min-height: calc(100vh - 88px);
        background: #f1f5f9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
    }
    
    .ai-auth-card {
        background: #ffffff;
        border-radius: 20px;
        padding: 40px;
        width: 100%;
        max-width: 480px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.05);
    }

    .ai-icon-bubble {
      width: 80px;
      height: 80px;
      background: rgba(16, 185, 129, 0.1);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 24px;
      color: #10b981;
      font-size: 32px;
      border: 1px solid rgba(16, 185, 129, 0.2);
    }

    .ai-title { color: #1a2234; text-align: center; font-size: 24px; font-weight: 800; margin-bottom: 8px; }
    .ai-subtitle { color: #64748b; text-align: center; font-size: 14px; margin-bottom: 32px; font-weight: 500; }

    .ai-otp-grid {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 12px;
      margin-bottom: 32px;
    }

    .ai-otp-input {
      width: 100%;
      height: 56px;
      background: rgba(238, 242, 246, 0.5);
      border: 1px solid rgba(0, 0, 0, 0.05);
      border-radius: 12px;
      color: #1a2234;
      font-size: 20px;
      font-weight: 700;
      text-align: center;
      transition: all 0.3s;
      outline: none;
      box-shadow: inset 0 2px 4px rgba(0,0,0,0.02);
    }

    .ai-otp-input:focus {
      border-color: #10b981;
      background: #ffffff;
      box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);
    }

    .ai-timer-box { text-align: center; margin-bottom: 24px; }

    .ai-timer-text {
      color: #10b981;
      font-weight: 600;
      font-size: 14px;
      background: rgba(16, 185, 129, 0.1);
      padding: 6px 16px;
      border-radius: 20px;
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }

    .db-modern-btn {
      background: linear-gradient(135deg, #10b981, #059669);
      color: #fff; border: none; padding: 16px; border-radius: 14px;
      font-weight: 700; width: 100%; font-size: 16px; letter-spacing: 1px;
      box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3); transition: 0.3s;
      text-transform: uppercase; display: flex; align-items: center; justify-content: center; gap: 8px;
    }
    .db-modern-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4); }
    .db-modern-btn:disabled { opacity: 0.7; cursor: not-allowed; }

    .ai-resend-box { text-align: center; margin-top: 24px; }
    .ai-resend-btn {
      background: transparent; border: none; color: #64748b; font-size: 14px; font-weight: 600; cursor: pointer; transition: color 0.3s;
    }
    .ai-resend-btn:hover:not(:disabled) { color: #10b981; text-decoration: underline; }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        <Sidebar />
        <Header />
        <section className="nftmax-adashboard nftmax-show">
          <div className="ai-auth-container">
            <div className="ai-auth-card">
              <div className="ai-icon-bubble">
                <i className="fa fa-shield-check"></i>
              </div>

              <h2 className="ai-title">Verification Code</h2>
              <p className="ai-subtitle">
                We've sent a 6-digit security code to your email <br />
                <span className="text-dark fw-bold">{email}</span>
              </p>

              <form onSubmit={verifyOTP}>
                <div className="ai-otp-grid">
                  {[0, 1, 2, 3, 4, 5].map((i) => (
                    <input
                      key={i}
                      type="text"
                      maxLength={1}
                      className="ai-otp-input"
                      ref={(el) => (inputsRef.current[i] = el)}
                      onInput={(e) => handleInput(e, i)}
                      onKeyDown={(e) => handleKeyDown(e, i)}
                      onPaste={handlePaste}
                      required
                    />
                  ))}
                </div>

                <div className="ai-timer-box">
                  {timer > 0 ? (
                    <div className="ai-timer-text">
                      <i className="fa fa-clock"></i>
                      {formatTime()}
                    </div>
                  ) : (
                    <div className="text-danger small fw-bold">Code has expired</div>
                  )}
                </div>

                <button
                  type="submit"
                  className="db-modern-btn"
                  disabled={isVerifying || timer === 0}
                >
                  {isVerifying ? "Verifying..." : "Verify Code"}
                </button>

                <div className="ai-resend-box">
                  <button
                    type="button"
                    className="ai-resend-btn"
                    onClick={resendOTP}
                    disabled={!canResend}
                  >
                    {canResend ? "Didn't receive code? Resend Code" : `Resend available in ${formatTime()}`}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}